import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';

import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { getProcesoByIdArea } from '../../../../redux/DucksUnidadInspeccion/ProcesosDuck';
import { getPreguntaInstalacionByIdTipoInstalacion } from '../../../../redux/DucksUnidadInspeccion/PreguntaInstalacionDuck';
import { getAllSeccionesCuestionario } from '../../../../redux/DucksUnidadInspeccion/SeccionCuestionarioDuck';
import Collapsible from 'react-collapsible';



function CuestionarioEnvasadoForm(props) {

    const dispatch = useDispatch();

    const { cuestionarioContext, setContextCuestionario } = useContext(InspectorEnCampoContext);

    const procesos = useSelector(store => store.Procesos.Proceso);
    const verdaderaInstalacion = props.verdaderaInstalacion;
    const todo = props.detalles;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;
    const idtipoinstalacion = todo?.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionescliente[0]?.tipoinstalacion?.idtipoinstalacion;
    const secciones = useSelector(store => store.SeccionCuestionario.SeccionCuestionario);
    const preguntas = useSelector(store => store.PreguntaInstalacion.PreguntaInstalacion);

    const [procesosArea, setProcesosArea] = React.useState([]);
    const [seccionesAreaEnvasado, setSeccionesAreaEnvasado] = React.useState([]);

    const [initialValues, setInitialValues] = React.useState({
        cuestionario: {
            calificacion: cuestionarioContext != null ? cuestionarioContext.procesosValores : [],
            observacion: cuestionarioContext != null ? cuestionarioContext.procesosComentarios : []
        }
    })

    useEffect(() => {
        dispatch(getProcesoByIdArea(14))
        dispatch(getAllSeccionesCuestionario())   //secciones  
        dispatch(getPreguntaInstalacionByIdTipoInstalacion(idtipoinstalacion))   //preguntas

        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        // }

    }, [])

    useEffect(() => {
        procesosArea
    }, [procesosArea])

    useEffect(() => {
        const procesos = []
        seccionesAreaEnvasado.forEach((s) => {
            preguntas.forEach((p) => {
                if (p.pregunta.idseccioncuestionario === s.idseccioncuestionario) {
                    procesos.push(p)
                }
            })
        })
        setProcesosArea(procesos)
    }, [preguntas])

    useEffect(() => {
        const result = []
        secciones.forEach((element) => {
            if (element.idseccioncuestionario === 14 || element.idseccioncuestionario === 15 || element.idseccioncuestionario === 16) {
                result.push(element)
                setSeccionesAreaEnvasado(result)
            }
        })

    }, [secciones])

    useEffect(() => {
        seccionesAreaEnvasado
    }, [seccionesAreaEnvasado])

    return (
        <Fragment>
            <Formik
                initialValues={initialValues}
                validate={(values) => {
                    const data = {
                        secciones: seccionesAreaEnvasado,
                        procesosPreguntas: procesosArea,
                        procesosValores: values.cuestionario.calificacion,
                        procesosComentarios: values.cuestionario.observacion
                    }

                    setContextCuestionario(data)
                }}
                onSubmit={(values) => {
                    //console.log(values)
                }}
            >
                {({ values }) => (
                    <Form>
                        <FieldArray
                            name='cuestionario'
                            render={arrayHelpers => (
                                <div>
                                    {
                                        seccionesAreaEnvasado.map((s) => {
                                            return (
                                                <Collapsible key={s.idseccioncuestionario} trigger={s.nombre_seccion} open={false} class={`row text-center`}>
                                                    {procesosArea &&
                                                        procesosArea.map((p, index) => {
                                                            return (
                                                                p.pregunta.idseccioncuestionario == s.idseccioncuestionario ?
                                                                    <div key={index}>
                                                                        <div className='row'>
                                                                            <div className="col-md-6 mb-3" style={{ fontSize: "14px" }}>
                                                                                <label htmlFor={`proceso.${index}`}>{p.pregunta.pregunta}</label>
                                                                            </div>
                                                                            <div className="col-md-2 mb-3">
                                                                                <Field
                                                                                    component="select"
                                                                                    className="form-control form-control-sm"
                                                                                    id={`cuestionario.calificacion.${index}`}
                                                                                    name={`cuestionario.calificacion.${index}`}
                                                                                    multiple={false}
                                                                                >
                                                                                    <option value={NaN}>- - - -</option>
                                                                                    <option value={3}>SI CUMPLE</option>
                                                                                    <option value={2}>NO CUMPLE</option>
                                                                                    <option value={1}>NO APLICA</option>
                                                                                </Field>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <Field type="text" as="textarea" className="form-control form-control-sm" id={`cuestionario.observacion.${index}`} name={`cuestionario.observacion.${index}`} placeholder="Comentarios" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div></div>
                                                            )
                                                        })
                                                    }
                                                </Collapsible>
                                            )
                                        })
                                    }
                                </div>
                            )}
                        />
                    </Form>
                )}
            </Formik>
        </Fragment>
    )
}

export default withRouter(CuestionarioEnvasadoForm)